import ApplicationContext from "domain/ApplicationContext";
import Bryntum from "domain/Bryntum";

export default function buildFilterQueryParameters({
  applicationContext,
  bryntumScheduler,
  visibleTimeRange,
  searchText,
  searchCategory,
  filters,
  ...extraArgs
}) {
  const scheduledBetweenInSiteTimeZone = getScheduledDateFilters({
    applicationContext,
    filterByScheduleView: filters.filterByScheduleView,
    scheduledBetween: filters.scheduledBetween,
    scheduleViewDateRange: extractDateRange(visibleTimeRange),
  });

  const filteredLineIds = () => {
    if (!filters.filterByScheduleView) return [];

    return Bryntum.filteredLineIds(bryntumScheduler);
  };

  return {
    ...extraArgs,
    filters: {
      ...filters,
      dueBetween: overrideTimeZone(filters.dueBetween, applicationContext),
      filteredLineIds: filteredLineIds(),
      materialAvailabilityBetween: overrideTimeZone(filters.materialAvailabilityBetween, applicationContext),
      plannedStartBetween: overrideTimeZone(filters.plannedStartBetween, applicationContext),
      scheduledBetween: scheduledBetweenInSiteTimeZone,
    },
    searchCategory,
    searchText,
  };
}

function extractDateRange({ startDate, endDate }) {
  return { endsAt: endDate, startsAt: startDate };
}

export function getScheduledDateFilters({
  filterByScheduleView,
  applicationContext,
  scheduleViewDateRange,
  scheduledBetween,
}) {
  if (filterByScheduleView) return overrideTimeZone(scheduleViewDateRange, applicationContext);

  return overrideTimeZone(scheduledBetween, applicationContext);
}

export function overrideTimeZone(dateRange, applicationContext) {
  if (!dateRange) return null;

  return {
    endsAt: ApplicationContext.overrideToSiteTimeZone(applicationContext, dateRange?.endsAt),
    startsAt: ApplicationContext.overrideToSiteTimeZone(applicationContext, dateRange?.startsAt),
  };
}
